<template>
<mainTemplateVue>
    <div>
        <md-toolbar :md-elevation="0" class="md-transparent">
            <h3 class="md-title">{{ $route.name }}</h3>
            <md-button class="md-primary" to="/configuracoes/medida">Voltar</md-button>
        </md-toolbar>
        
        <div>
            <md-card>
                <md-card-content>
                    <form class="md-layout">
                        <md-field>
                            <label for="unidadeMedida_nome">Nome</label>
                            <md-input v-model="form.unidadeMedida_nome" name="unidadeMedida_nome" id="unidadeMedida_nome" :disabled="sending" required/>
                            <span class="md-helper-text">Insira o nome da unidade medida</span>
                        </md-field>

                        <md-field>
                            <label for="unidadeMedida_codigo">Código</label>
                            <md-input  v-model="form.unidadeMedida_codigo" name="unidadeMedida_codigo" id="unidadeMedida_codigo"  :disabled="sending" required/>
                            <span class="md-helper-text">Insira o código da unidade de medida</span>
                        </md-field>
                    </form>
                </md-card-content>
                
                <md-card-actions md-alignment="left">
                    <md-button class="md-primary" @click="saveAndToList" :disabled="sending">Salvar</md-button>
                    <md-button class="md-primary" :disabled="sending" @click="saveAndCreateNew">Salvar e criar novo</md-button>
                    <md-button class="md-accent" :disabled="sending" @click="cancel">Cancelar</md-button>
                </md-card-actions>
            </md-card>
        </div>

        <md-snackbar :md-active.sync="showSnackMessage">{{snackMessage}}</md-snackbar>
    </div>
</mainTemplateVue>
</template>

<script>
import mainTemplateVue from '../../../../components/main-template.vue'
import { api } from '../../../../services/api'

export default {
    name: 'unidade-medida-form',
    components: {
        mainTemplateVue
    },
    data: () => ({
        id: null,
        seekingError: false,
        showSnackMessage: false,
        snackMessage: false,
        sending: false,
        saved: false,
        error: false,
        form: {
            unidadeMedida_nome: null,
            unidadeMedida_codigo: null
        }
    }),
    watch: {
    },
    methods: {
        async saveAndCreateNew(){
            if(this.form.unidadeMedida_nome !== null || this.form.unidadeMedida_codigo !== null){
                this.save().then(() => {
                    this.form.unidadeMedida_codigo = null
                    this.form.unidadeMedida_nome = null
                }).catch(() => {
                    this.error = true
                })
            }
        },

        async saveAndToList(){
            if(this.form.unidadeMedida_nome !== null || this.form.unidadeMedida_codigo !== null){
                this.save().then(() => {
                    setTimeout(() => {
                        this.$router.push({ path: '/estoque/medida' })
                    }, 1000);
                }).catch(() => {
                    this.error = true
                })
            }
        },

        async save(){
            this.sending = true

            let res;

            if(this.id !== null) {
                res = await api().put(`/estoque/medida/${this.id}`, {
                    unidadeMedida_nome: this.form.unidadeMedida_nome,
                    unidadeMedida_codigo: this.form.unidadeMedida_codigo
                })
            } else {
                res = await api().post('/estoque/medida', {
                    unidadeMedida_nome: this.form.unidadeMedida_nome,
                    unidadeMedida_codigo: this.form.unidadeMedida_codigo
                })
            }

            this.sending = false
            this.showSnackMessage = true
            this.snackMessage = true
                
            if(!res) {
                this.snackMessage = "Ocorreu um erro ao salvar o registro"
                return false
            }
            
            this.snackMessage = "Registro salvo com sucesso"

            return true
        },

        async getItem(){
            this.sending = true

            let res = await api().get(`/estoque/medida/${this.id}`)

            if(!res){
                this.seekingError = true
                return false
            }

            this.sending = false
            this.form = { ...res.data.data }
        },

        cancel(){
            this.$router.push({ path: '/estoque/medida' })
        }
    },
    created () {
        if(this.$route.params.id && !isNaN(this.$route.params.id)) {
            this.id = this.$route.params.id
            this.getItem()
        }
    },

    mounted() {
    },
}
</script>

<style>
</style>